module.exports = __webpack_public_path__ + "img/p-11-4.e9b414f7.png";